export const NAVBAR_CONTAINER_ID = 'mercury-navbar-container'
